import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {bulkUnarchiveProcessManagement} from 'archive/ArchiveActions';
import isArchivable from 'archive/isArchivable';
import isArchived from 'archive/isArchived';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {openArchiveModalForProcessItems} from 'processes/archive/archiveUtil';
import {ProcessForToolbar} from 'processes/process-details/toolbar/ProcessActionToolbar';
import Tooltip from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

interface ProcessArchiveButtonProps {
  process: ProcessForToolbar;
  forceRefetch: () => Promise<unknown>;
}

function archiveProcess(process: ProcessForToolbar, forceRefetch: () => Promise<unknown>): void {
  openArchiveModalForProcessItems({
    itemType: ModelTypeConstants.PROCESS,
    items: [process],
    afterArchive: (_archiveResponse, _purpose) => {
      forceRefetch();
    },
  });
}

function unarchiveProcess(process: ProcessForToolbar, forceRefetch: () => Promise<unknown>): void {
  bulkUnarchiveProcessManagement(ModelTypeConstants.PROCESS, [process.id]).then(() => {
    forceRefetch();
  });
}

export default function ArchiveProcessButton(props: ProcessArchiveButtonProps): JSX.Element {
  const isProcessArchivable = isArchivable(props.process);
  const isProcessArchived = isArchived(props.process);
  return (
    <Tooltip
      title={
        isProcessArchivable
          ? isProcessArchived
            ? 'Unarchive task group'
            : 'Archive task group'
          : 'Task group cannot be archived.'
      }
    >
      <Button
        buttonStyle={isProcessArchived ? ButtonStyle.SECONDARY : ButtonStyle.TERTIARY_GRAY}
        className={classNames('u-mini-spacing-left', css(styles.archiveButton))}
        disabled={!isProcessArchivable}
        icon={isProcessArchived ? 'unarchive' : 'archive'}
        iconAltText={isProcessArchived ? 'Unarchive' : 'Archive'}
        onClick={() => {
          (isProcessArchived ? unarchiveProcess : archiveProcess)(props.process, props.forceRefetch);
        }}
        size={ButtonSize.MINI}
      />
    </Tooltip>
  );
}

const styles = StyleSheet.create({
  archiveButton: {
    height: '28px',
    width: '28px',
  },
});
